import { apiGet, apiPost, apiPut } from '.';
import {
  BareStaffTemplate,
  StaffTemplate,
  NewStaffTemplate,
  SimpleStaffTemplate,
  PaginateStaffTemplateParams,
} from '../../../shared/types/staffTemplate';
import { populateStaffTemplate } from '@go-shared/lib/staff';
import { PaginationResult } from '@go-shared/types/pagination';
import qs from 'query-string';

export async function getSimpleStaffTemplates(): Promise<SimpleStaffTemplate[]> {
  let staffTemplates = (await apiGet(`/simple-staff-template`)) as any;

  return staffTemplates;
}

export async function getStaffTemplatesByPropertyId(
  propertyId: string
): Promise<BareStaffTemplate[]> {
  let staffTemplates = (await apiGet(`/property/${propertyId}/staff-template`)) as any;

  return staffTemplates;
}

export const populate = populateStaffTemplate;

export function bare(staffTemplate: StaffTemplate): BareStaffTemplate {
  return {
    ...staffTemplate,
    department: staffTemplate.department._id,
    berthing: staffTemplate.berthing._id,
    property: staffTemplate.property._id,
  };
}

export async function create(newTemplate: NewStaffTemplate): Promise<BareStaffTemplate> {
  return apiPost(`/property/${newTemplate.property}/staff-template`, newTemplate);
}

export async function update(staffTemplate: BareStaffTemplate): Promise<BareStaffTemplate> {
  return apiPut(
    `/property/${staffTemplate.property}/staff-template/${staffTemplate._id}`,
    staffTemplate
  );
}

/**
 * Generates a CSV file with the Staff templates data
 */
export const exportStaffTemplatesToCSV = (propertyId: string) => {
  return apiGet<{ location: string }>(`/property/${propertyId}/staff-template/export-csv`);
};

export async function paginateStaffTemplates(
  params: PaginateStaffTemplateParams
): Promise<PaginationResult<StaffTemplate>> {
  return apiGet(`/staff-template/paginate?${qs.stringify(params)}`);
}
